import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Chengyuantongzhi"
});
const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M13.9176 11.5391C16.4996 12.0681 19.5033 13.7908 19.5033 18.7588C19.5033 20.0836 17.7577 20.0836 12.1042 20.0836C6.3803 20.0836 4.70508 20.0836 4.70508 18.7588C4.70508 13.8575 7.70642 12.0703 10.2907 11.5391C8.26639 10.4788 7.56818 8.02924 8.5452 6.04204C9.52222 4.05484 11.9659 3.32576 13.8497 4.38604C15.7334 5.44632 16.5019 7.89587 15.4546 9.81638C15.1032 10.6121 14.5455 11.1412 13.9176 11.5391Z",
  fill: "#BDC3CD"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  opacity: "0.6",
  d: "M8.07671 11.459C8.29695 11.3968 8.35318 11.1256 8.17043 10.9922C6.54909 9.81413 6.05239 7.62244 6.94037 5.81529C7.07158 5.54855 7.22856 5.30404 7.40896 5.08398C7.55891 4.90171 7.40428 4.63719 7.16061 4.6572C6.11096 4.74167 5.11988 5.35516 4.6138 6.38433C3.90623 7.82249 4.2811 9.55851 5.53693 10.5277C5.71031 10.6632 5.65877 10.9255 5.44321 10.99C3.50558 11.5635 1.5 13.0906 1.5 16.6982C1.5 17.2517 1.85847 17.5184 2.84018 17.6496C2.99716 17.6696 3.14242 17.5629 3.15882 17.4117C3.54541 13.6952 5.86495 12.0792 8.07671 11.459V11.459Z",
  fill: "#BDC3CD"
}, null, -1);
const _hoisted_4 = /* @__PURE__ */ createElementVNode("path", {
  opacity: "0.6",
  d: "M15.9231 11.459C15.7029 11.3968 15.6467 11.1256 15.8294 10.9922C17.4507 9.81413 17.9474 7.62244 17.0595 5.81529C16.9283 5.54855 16.7713 5.30404 16.5909 5.08398C16.4409 4.90171 16.5956 4.63719 16.8392 4.6572C17.8889 4.74167 18.8799 5.35516 19.386 6.38433C20.0936 7.82249 19.7187 9.55851 18.4629 10.5277C18.2895 10.6632 18.3411 10.9255 18.5566 10.99C20.4943 11.5635 22.4998 13.0906 22.4998 16.6982C22.4998 17.2517 22.1414 17.5184 21.1597 17.6496C21.0027 17.6696 20.8574 17.5629 20.841 17.4117C20.4544 13.6952 18.1349 12.0792 15.9231 11.459V11.459Z",
  fill: "#BDC3CD"
}, null, -1);
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_5);
}
var chengyuantongzhi = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { chengyuantongzhi as default };
